import { DateTime } from "luxon";

export const formatLocalTimestamp = (utcDateString: string): string => {
  return DateTime.fromISO(utcDateString).toLocaleString(DateTime.DATETIME_MED);
}

export const getCurrentHour = () => {
  return DateTime.utc().startOf('hour');
}

export const getNextHour = () => {
  return getCurrentHour().plus({ hours: 1 });
}